
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import type { ClasshourDetail as TClasshourDetail } from '@xt/client/entities/course-v2/types.d'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'

@Observer
@Component({
  components: {
    EmptyStatus
  }
})
export default class ClasshourMaterial extends Vue {
  @Prop({ default: () => [] }) data: TClasshourDetail['materialList']

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }
  get GuideData() {
    return this.$store.$courseV2.GuideData
  }
  get oss() {
    return this.$store.$OSS
  }
  get ClasshourStore() {
    return this.$store.$storeCourse.Details.Map.Details
  }

  async onDownload(item: TClasshourDetail['materialList'][number]) {
    try {
      const filePath = item.filePath
      if (!filePath) {
        this.$msg('下载失败')
        return false
      }
      this.ClasshourStore.onAddCourseMaterials(item.id)
      let url = await this.oss.onGetFilesUrl(filePath)
      this.onOpenBlock(url, encodeURIComponent(item.name))
    } catch (error) {
      console.log('Clin -> file: classhour.ts -> line 170 -> download -> error', error)
    }
  }

  getFileIconUrlByFileName(filename: string) {
    let suffix = filename.split('.').pop()

    if (!suffix) {
      return this.$images.homework_material_unknown
    }

    suffix = suffix.toLowerCase()

    switch (suffix) {
      case 'mp4':
        return this.$images.homework_material_mp4
      case 'mp3':
        return this.$images.homework_material_mp3
      case 'png':
        return this.$images.homework_material_png
      case 'jpg':
      case 'jpeg':
        return this.$images.homework_material_jpg
      case 'gif':
        return this.$images.homework_material_gif
      case 'doc':
      case 'docx':
        return this.$images.homework_material_doc
      case 'xls':
      case 'xlsx':
        return this.$images.homework_material_xls
      case 'ppt':
      case 'pptx':
        return this.$images.homework_material_ppt
      case 'pdf':
        return this.$images.homework_material_pdf
      case 'txt':
        return this.$images.homework_material_text
      case 'zip':
        return this.$images.homework_material_zip
      default:
        return this.$images.homework_material_unknown
    }
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
